import { setToken, getToken, setAdmin, getAdmin } from '@/assets/js/util'

export default {
    state: {
        token: getToken() ? getToken() : '',
        admin_info: JSON.parse(getAdmin('admin_info')) ? JSON.parse(getAdmin('admin_info')) : '',
        organ_id: getAdmin('organ_id') ? getAdmin('organ_id') : '',
        organ: getAdmin('organ'),
        domain: getAdmin('domain') ? getAdmin('domain') : 'zz'
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
            setToken(token)
        },
        setAdmin_info(state, data) {
            state.admin_info = data;
            setAdmin('admin_info', data)
        },
        setAdmin_city(state, data) {
            state.organ_id = data
            setAdmin('organ_id', data)
        },
        setAdmin_city_two(state, data) {
            state.organ = data
            setAdmin('organ', data)
        },
        setAdmin_domain(state, domain) {
            state.domain = domain
            setAdmin('domain', domain)
        }
    },
    getters: {

    },
    actions: {
        // 登录
        Login({ commit }, { token, admin_info, organ_id }) {
            commit('setToken', token)
            commit('setAdmin_info', admin_info)
            commit('setAdmin_city', organ_id)
        },
        // 退出登录
        LogOut({ commit }) {
            commit('setToken', '')
            commit('admin_info', '')
            commit('organ_id', '')
        },
        // 切换门店id
        SetCity({ commit }, { value }) {
            commit('setAdmin_city', value)
        },
        // 门店名称
        SetCityTwo({ commit }, { value }) {
            commit('setAdmin_city_two', value)
        },
        // 门店简称
        SetDomain({ commit }, { domain }) {
            // console.log(domain)
            commit('setAdmin_domain', domain)
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/module/user.js